/*
 *
 * Test Portfolio Header
 *
 */

import React from "react";
import Helmet from "react-helmet";
import { Container, Col, Row } from "react-bootstrap";

const Header = () => (
  <Container fluid className="title-bar mb-3">
    <Helmet
      title="Invoice Payment - Criteria"
      meta={[
        { name: "description", content: "Description of Invoice Payment" },
      ]}
    />{" "}
    <Row>
      <Col>
        <h1 className="page-header">Invoice Payment</h1>
      </Col>
    </Row>
  </Container>
);

export default Header;
